module.exports = "<h1>Hi!</h1>\n<p>You're logged in with The BL-Innovation!!</p>\n"